import * as React from 'react';
import CreateRequestWrapper from '../../../Modules/Exchange/components/Exchange/CreateRequest/CreateRequestWrapper';
var Request = function (props) {
    return (React.createElement("div", null,
        React.createElement(CreateRequestWrapper, { onOrderCreated: props.setExchange, goToNewRequest: props.goToNewRequest })));
};
export default Request;
